import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { AbaWebSessionSx, IconTitleSessionSx, SessaoTratamentoEventosSx, TitleSessionSx } from './RightSessionSx'
import { Apartment, GppGood, Groups, HourglassBottom, Image, Build, Person, FormatListBulleted } from '@mui/icons-material'
import { useContext, useEffect, useState } from 'react'
import { CondominiosContext } from '../../../Providers/CondominiosContext/CondominiosContext'
import { ModalGerarEvento } from '../ModalGerarEvento/ModalGerarEvento'
import SmallButton from '../../../Components/SmallButton/SmallButton'
import AbaWeb from '../AbaWeb/AbaWeb'
import EntregaTab from '../../../../src/Pages/VisitantesPage/EntregasTab/EntregasTab.jsx'
import { TratarEvento } from '../TratarEvento/TratarEvento'
import ShowComponent from '../../../Components/ShowComponent/ShowComponent'
import { ChangeComponentContext } from '../../../Providers/ChangeComponentContext/ChangeComponentContext'
import LivroAta from '../../../Components/LivroAta/LivroAta'
import HistoricoEventos from '../../../Components/HistoricoEventos/HistoricoEventos'
import AcessosAoVivo from '../../../Components/AcessosAoVivo/AcessosAoVivo'
import pilhaHorizontal from '../../../Assets/icones/pilha-horizontal.svg'
import Nobreak from '../../../Components/Nobreak/Nobreak'
import OrdemServico from '../../../Components/OrdemServico/OrdemServico'
import CaixaAgua from '../../../Components/CaixaAgua/CaixaAgua'
import caixaAguaIcone from '../../../Assets/icones/gota-button.svg'
import InfoCondIcone from "../../../Assets/icones/info-condominio.svg"
import CondominioInfo from '../../../Components/CondominioInfo/CondominioInfo'
import { Tooltip } from '@mui/material'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import VisitantesPage from '../../VisitantesPage/VisitantesPage'
import { VisitantesProvider } from '../../../Providers/VisitantesContext/VisitantesContext'
import { EventosContext } from '../../../Providers/EventosContext/EventosContext'
import { UserContext } from '../../../Providers/UserContext/UserContex'
import OcorrenciasPage from '../../OcorrenciasPage/OcorrenciasPage'
import Ronda from '../../../Components/Ronda/Ronda'
import ImgEvento from '../../ImgEvento/ImgEvento'
import { EncomendaProvader } from '../../../Providers/EncomendaContext/EncomendaContext'
import box1 from '../../../Assets/icones/caixaBranca.svg'

export const RightSession = () => {
    const { activeCond } = useContext(CondominiosContext)
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [openGerarEvento, setOpenGerarEvento] = useState(false)
    const [openInfoCondominio, setOpenInfoCondominio] = useState(false)
    const [caixaAgua, setCaixaAgua] = useState(false)
    const [nobreak, setNobreak] = useState(false)
    const {
        showAbaWeb,
        killAbaWeb,
        showTratarEvento,
        killTratarEvento,
        showLivroAta,
        killLivroAta,
        showHistoricoEventos,
        showAcessosAoVivo,
        showNobreak,
        killOrdemServico,
        changeShowComponent,
        showOrdemServico,
        showCaixaAgua,
        showVisitantes,
        showOcorrencias,
        showRonda,
        showImgEvento,
        killImgEvento,
        showEntregasTab
    } = useContext(ChangeComponentContext)
    const { eventoSelecionado } = useContext(EventosContext)
    const { user, check } = useContext(UserContext)

    const handleAbaVisitante = () => {
        const testeVisitante = false
        if (testeVisitante) {
            changeShowComponent('visitantes-tratarEvento')
        } else {
            if (eventoSelecionado.evento != '') {
                changeShowComponent('visitantes-tratarEvento')
            } else {
                addRoute("gerarEventoVisitante", (msg) => {
                    if (msg.data.status) {
                        setTimeout(() => {
                            changeShowComponent('visitantes-tratarEvento')
                        }, 500)
                    }
                })
                const ramal = check.estado_jornada == 1 ? check.ramal : false

                sendWs("gerarEventoVisitante", {
                    id_central: activeCond.id_central,
                    evento: 'OVIS',
                    auxiliar: '',
                    nomeUsuario: user.nome,
                    idUsuario: user.id,
                    ramal
                })
                // showNotify('warning', 'Selecione um evento que vocês esteja tratanto!')
            }
        }
    }

    useEffect(() => {
        if (activeCond.id_central) {
            addRoute('getAtivoCaixaAguaENobreak', AtivoCaixaAguaENobreak)
            sendWs("getAtivoCaixaAguaENobreak", { filtros: { id_central: activeCond.id_central } })
        }
        changeShowComponent('abaWeb-tratarEvento')
    }, [activeCond])

    const AtivoCaixaAguaENobreak = (msg) => {
        let resposta = msg.data.dados
        if (msg.data && msg.data.status) {
            setCaixaAgua(resposta.caixaDAgua)
            setNobreak(resposta.nobreak)
        }
    }

    const abrirImagensCond = () => {
        if (global.Enviar_Mensagem_AbaWeb && typeof global.Enviar_Mensagem_AbaWeb == 'function') {
            global.Enviar_Mensagem_AbaWeb({ cmd: 'abrir_imagens_cond' }) // Envia o id_one_log do evento selecionado para aba web
        }
    }

    return (
        <>
            {/* title session */}
            <Grid sx={TitleSessionSx} mb={0.5} mt={0.5} key="titleSession" display={activeCond?.id_central ? 'flex' : 'none'} xs={12}>
                <Grid md={5} container sx={{ alignItems: 'center', overflow: 'hidden', flexWrap: 'nowrap' }}>
                    <Apartment sx={IconTitleSessionSx} /><span style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                    }}>{activeCond.apelido ? ` - ${activeCond.apelido} - ` : ''}</span>
                    <Tooltip title="Abrir Informação do condominio" placement="bottom" arrow>
                        <img
                            style={{
                                height: '20px',
                                width: '20px',
                                marginLeft: '5px',
                                cursor: 'pointer'
                            }}
                            src={InfoCondIcone}
                            onClick={() => setOpenInfoCondominio(!openInfoCondominio)}

                        />
                    </Tooltip>
                </Grid>
                {openInfoCondominio &&
                    <CondominioInfo
                        openInfoCondominio={openInfoCondominio}
                        setOpenInfoCondominio={setOpenInfoCondominio}
                        idCondAtivo={activeCond.id_central}
                    />}
                {openGerarEvento &&
                    <ModalGerarEvento
                        openGerarEvento={openGerarEvento}
                        setOpenGerarEvento={setOpenGerarEvento}
                        idCondAtivo={activeCond.id_central}
                        nomeCondAtivo={activeCond.nome}
                    />}
                <Grid md={8} container sx={{ alignItems: 'center', justifyContent: 'flex-end', paddingRight: '3px', gap: 1 }}>
                    <SmallButton
                        height="22px"
                        title="Abrir Aba Web"
                        disabled={!activeCond?.id_central}
                        onClick={() => {
                            changeShowComponent('abaWeb-tratarEvento'); setTimeout(() => {}, 10)
                        }}
                        IconStart={Apartment}
                        active={showAbaWeb}
                    >
                    </SmallButton>
                    <SmallButton
                        height="22px"
                        title="Entrega"
                        disabled={!activeCond?.id_central}
                        onClick={() => { changeShowComponent('EntregasTab') }}
                        active={showEntregasTab}
                    >
                        <img style={{ height: '14px', width: '20px' }} src={box1}></img>
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title='Ocorrências'
                        onClick={() => changeShowComponent('ocorrencias-tratarEvento')}
                        IconStart={FormatListBulleted}
                        active={showOcorrencias} >
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title='Visitantes (obrigatório estar em jornada)'
                        onClick={() => handleAbaVisitante()}
                        IconStart={Person}
                        active={showVisitantes}
                        disabled={
                            !activeCond?.id_central ||
                            (!check || !check.estado_jornada || (check.estado_jornada == 2 || check.estado_jornada == 4)) ||
                            (eventoSelecionado.evento && (
                                (eventoSelecionado.evento != 'OINI' && eventoSelecionado.evento != 'OVIS') ||
                                eventoSelecionado.status != 2 ||
                                user.id != eventoSelecionado.usuario_tratando.id
                            ))
                        }
                    >
                    </SmallButton>

                    { caixaAgua
                        ? <SmallButton
                            height="22px"
                            title="Abrir Caixa D'agua"
                            disabled={!activeCond?.id_central}
                            onClick={() => {
                                changeShowComponent('caixaAgua-tratarEvento'); setTimeout(() => {}, 10)
                            }}
                            active={showCaixaAgua} >
                            <img style={{ height: '14px', width: '14px' }} src={caixaAguaIcone}
                            />
                        </SmallButton>
                        : ''
                    }

                    { nobreak
                        ? <SmallButton
                            height="22px"
                            title="Abrir No-Break"
                            disabled={!activeCond?.id_central}
                            onClick={() => {
                                changeShowComponent('nobreak-tratarEvento'); setTimeout(() => {}, 10)
                            }}
                            active={showNobreak} >
                            <img style={{ height: '22px', width: '22px' }} src={pilhaHorizontal} />
                        </SmallButton>
                        : ""
                    }

                    <SmallButton
                        height="22px"
                        title='Ordem de Serviço'
                        onClick={() => changeShowComponent('ordemServico')}
                        IconStart={Build}
                        active={showOrdemServico} >
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title="Abrir Acessos ao Vivo"
                        disabled={!activeCond?.id_central}
                        onClick={() => {
                            changeShowComponent('acessosAoVivo-tratarEvento'); setTimeout(() => {}, 10)
                        }}
                        IconStart={Groups}
                        active={showAcessosAoVivo} >
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title="Abrir Histórico de Eventos"
                        disabled={!activeCond?.id_central}
                        onClick={() => {
                            changeShowComponent('historicoEventos-tratarEvento'); setTimeout(() => {}, 10)
                        }} IconStart={HourglassBottom}
                        active={showHistoricoEventos} >
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title="Abrir Imagens do Condomínio"
                        onClick={() => { changeShowComponent('abaWeb-tratarEvento'); abrirImagensCond() }}
                        IconStart={Image}
                        disabled={!activeCond?.id_central} >
                    </SmallButton>

                    <SmallButton
                        height="22px"
                        title="Gerar Evento Manual"
                        onClick={() => setOpenGerarEvento(true)}
                        disabled={!activeCond?.id_central}
                        IconStart={GppGood}
                        active={openGerarEvento} >
                    </SmallButton>
                </Grid>
            </Grid>

            <Grid sx={AbaWebSessionSx}>
                <ShowComponent show={showAbaWeb} kill={killAbaWeb}>
                    <AbaWeb link={activeCond.link} />
                </ShowComponent>
                <ShowComponent show={showCaixaAgua} kill={!showCaixaAgua}>
                    <CaixaAgua />
                </ShowComponent>
                <ShowComponent show={showNobreak} kill={!showNobreak}>
                    <Nobreak />
                </ShowComponent>
                <ShowComponent show={showLivroAta} kill={killLivroAta}>
                    <LivroAta />
                </ShowComponent>
                <ShowComponent show={showHistoricoEventos} kill={!showHistoricoEventos}>
                    <HistoricoEventos />
                </ShowComponent>

                <ShowComponent show={showAcessosAoVivo} kill={!showAcessosAoVivo}>
                    <AcessosAoVivo />
                </ShowComponent>

                <ShowComponent show={showOrdemServico} kill={killOrdemServico}>
                    <OrdemServico />
                </ShowComponent>

                <ShowComponent show={showRonda} kill={!showRonda}>
                    <Ronda idCentral={activeCond.id_central} />
                </ShowComponent>
                <ShowComponent show={showEntregasTab} kill={!showEntregasTab}>
                    <VisitantesProvider>
                        <EncomendaProvader>
                            <EntregaTab ativoNavBar={true}/>
                        </EncomendaProvader>
                    </VisitantesProvider>
                </ShowComponent>

                <ShowComponent show={showVisitantes} kill={!showVisitantes} >
                    <VisitantesProvider>
                        <EncomendaProvader>
                            <VisitantesPage />
                        </EncomendaProvader>
                    </VisitantesProvider>
                </ShowComponent>
                <ShowComponent show={showOcorrencias} kill={!showOcorrencias}>
                    <OcorrenciasPage />
                </ShowComponent>
                <ShowComponent show={showImgEvento} kill={killImgEvento}>
                    <ImgEvento evento={eventoSelecionado}/>
                </ShowComponent>
            </Grid>

            {/* Sessão trata evento */}
            <ShowComponent show={showTratarEvento} kill={killTratarEvento}>
                <Grid container xs={12} sx={SessaoTratamentoEventosSx}>
                    <TratarEvento />
                </Grid>
            </ShowComponent>

        </>
    )
}
